import { Helpers } from "./helpers/helpers";;

export class Filters {
	constructor() {
		const tileContainer = document.querySelector('.tile-filter-widget');
		const tiles = tileContainer?.querySelectorAll('.tile');
		const filterContainer = document.querySelector('.filters');

		tiles?.forEach(tile => {
			tile.addEventListener('click',
				(e) => {
					e.preventDefault();
					let tile = e.target as HTMLElement;
					let parentCategory = "";
					if (tile.classList.contains('.tile')) {
						parentCategory = tile.dataset.category;
					} else {
						tile = tile.closest('.tile');
						parentCategory = tile.dataset.category;
					}
					
					if (tile.classList.contains('active')) {
						tile.classList.remove('active'); 
						filterContainer.classList.remove('open'); //close tab if already open
					} else {
						tiles.forEach(list => list.classList.remove('active'));
						tile.classList.add('active');
						const filterList = filterContainer.querySelector(`.filter-list[data-category="${parentCategory}"]`);
						filterContainer.querySelectorAll('.filter-list').forEach(list => list.classList.add('d-none'));
						filterList?.classList.remove('d-none');

						filterContainer.classList.add('open');
					}
				});

		});

		document?.querySelectorAll('.filter-list .has-children, .more-filters .has-children').forEach(list => {
			list.querySelector(':scope > .more-indicator').addEventListener('click',() => {
				list.classList.toggle('open');
			});
		});

		document?.querySelectorAll('.filter-list > h2').forEach(list => {			
			list.addEventListener('click',() => {
				(list.closest(".filter-list") as HTMLElement).classList.toggle('open');
			});
		});
		
		
		document.addEventListener('click',
			(e) => {
				if (Helpers.isNullOrUndefined(filterContainer)) {
					return true;
				}
				const isClickInside = filterContainer?.contains(e.target as HTMLElement) || tileContainer?.contains(e.target as HTMLElement);

				if (!isClickInside) {
					filterContainer?.classList.remove('open');
					tiles?.forEach(list => list.classList.remove('active'));
				}
			});

	}


}